import { useState } from 'react';

const CategoryInfo = ({ info }: { info: string }) => {
  const [showInfo, setShowInfo] = useState(false);

  return (
    <div
      role="button"
      onClick={() => setShowInfo(!showInfo)}
      className={`calculator_info mw-m cursor-pointer br-05 bg-light-yellow px-1 py-1 d-flex align-center gap-1 ${
        showInfo ? 'calculator_info-open' : ''
      }`}
    >
      <img
        src={`${
          process.env.NODE_ENV !== 'development'
            ? 'https://painting-frontend.vercel.app'
            : ''
        }/info.svg`}
        alt="info"
      />
      <small>{info}</small>
      <img
        width={24}
        height={24}
        className="cursor"
        src={`${
          process.env.NODE_ENV !== 'development'
            ? 'https://painting-frontend.vercel.app'
            : ''
        }/arrowdown.svg`}
        alt="open/close info"
      />
    </div>
  );
};

export default CategoryInfo;
